import Loader from "~/components/shared/Loader.jsx";

import AuthForm from "../components/auth-form";
import ProfilePage from "../components/profile-page";
import { useStatus } from "../hooks/use-status";
import styles from "./profile.module.css";

const Profile = () => {
  const { userData, isPending } = useStatus();
  const userIsVerified = userData?.verified;
  if (isPending) {
    return (
      <div className={styles.loading}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={`${styles.page} vanda no-scrollbar`}>
      {userIsVerified && userData ? <ProfilePage data={userData} /> : <AuthForm />}
    </div>
  );
};

export default Profile;
